import React from "react";

import { CardHeader } from "@material-ui/core";

import ContactAvatar from "../ContactAvatar";
import { contactDisplayName } from "../../utils/contactPresentation";

import WaitingStatus from "../WaitingStatus";

import { i18n } from "../../translate/i18n";

const TicketInfo = ({ contact, ticket, onClick }) => {
	return (
		<CardHeader
			onClick={onClick}
			style={{ cursor: "pointer" }}
			titleTypographyProps={{ noWrap: true }}
			subheaderTypographyProps={{ noWrap: true }}
			avatar={<ContactAvatar contact={contact} />}
			title={`${contactDisplayName(contact)} #${ticket.id}`}
			subheader={
				<>
					{ticket.user && `${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`}
					<WaitingStatus ticket={ticket} />
				</>
			}
		/>
	);
};

export default TicketInfo;
